var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelemetryBreadCrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5356 6.46444C15.4882 8.41707 15.4882 11.5829 13.5356 13.5355M6.46455 13.5355C4.51193 11.5829 4.51193 8.41704 6.46455 6.46442M4.10752 15.8925C0.853156 12.6382 0.853156 7.36179 4.10752 4.10742M15.8926 4.10746C19.147 7.36183 19.147 12.6382 15.8926 15.8926M11.6667 9.99998C11.6667 10.9205 10.9206 11.6666 10.0001 11.6666C9.07961 11.6666 8.33342 10.9205 8.33342 9.99998C8.33342 9.0795 9.07961 8.33331 10.0001 8.33331C10.9206 8.33331 11.6667 9.0795 11.6667 9.99998Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemetryBreadCrumbs);
export default __webpack_public_path__ + "static/media/telemetryBreadCrumbs.a1471cb18516000399e435def1a22a48.svg";
export { ForwardRef as ReactComponent };